<template>
    <p class="note" v-if="userIsActive">
      Your account is inactive, kindly activate and enjoy full benefits
    </p>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UsersWithoutDevice",
  components: {},

  data() {
    return {
      userIsActive: false,
    };
  },

  computed: {
    ...mapGetters(["getloggedinUserRole", "getloggedinUserInstallationCount"]),
  },

  methods: {
    userWithoutDevice() {
        const hasNoInstallation = this.getloggedinUserInstallationCount === 0;
        const isCustomer = this.getloggedinUserRole.toLowerCase() === "customer";
        this.userIsActive = hasNoInstallation && isCustomer;
    },
  },
  
  watch: {
    getloggedinUserInstallationCount: "userWithoutDevice",
    getloggedinUserRole: "userWithoutDevice",
  },


 
  mounted() {
    this.userWithoutDevice();
  },
};
</script>

<style>
.note {
  background-color: #b6f4ce;
  padding: 12px;
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/UsersWithoutDevice.vue